/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';

import { Grid, Row, Column } from 'uikit/grids';
import { Skeleton } from 'uikit/loaders';
import { Typo } from 'uikit/content';
import ProfileCredentialsList from './profileCredentialsList';

import styles from '../styles/profileCredentialsCategoryList.module.scss';

const ProfileCredentialsCategoryList = ({
  categories = [],
  isCurrentUser = false,
  isLoading = true,
  isMyLearning = false,
  onCredentialClick = () => {},
}) =>
  isLoading ? (
    [...Array(2).keys()].map((_, index) => (
      <div className={styles.category} key={index}>
        <Skeleton className={styles.title} height={20} width={200} />
        <Grid>
          <Row sizes={{ default: 1, medium: 2, large: isMyLearning ? 2 : 3 }}>
            {[...Array(isMyLearning ? 2 : 3).keys()].map((__, subIndex) => (
              <Column key={subIndex}>
                <Skeleton height={102} width="100%" />
              </Column>
            ))}
          </Row>
        </Grid>
      </div>
    ))
  ) : categories.length ? (
    categories.map((category, index) => (
      <div className={styles.category} key={index}>
        <Typo className={styles.title} element="h3" variant="s03" weight="medium">
          {category.name}
        </Typo>
        <ProfileCredentialsList
          credentials={category.credentials}
          isCurrentUser={isCurrentUser}
          isMyLearning={isMyLearning}
          onCredentialClick={onCredentialClick}
        />
      </div>
    ))
  ) : (
    <div className={styles.placeholder}>
      <Typo element="h2" variant="d02">
        {i18n.t('no-credentials-earned-yet')}
      </Typo>
      <Typo color="secondary" element="p" variant="b01">
        {i18n.t('no-credentials-earned-yet-description')}
      </Typo>
    </div>
  );

ProfileCredentialsCategoryList.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      credentials: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          description: PropTypes.string,
        }),
      ),
    }),
  ),
  isCurrentUser: PropTypes.bool,
  isLoading: PropTypes.bool,
  isMyLearning: PropTypes.bool,
  onCredentialClick: PropTypes.func,
};

export default React.memo(ProfileCredentialsCategoryList);
